/** Shared copy and helpers for identity confirmation on signature fields. */

export const SIGNATURE_ACKNOWLEDGEMENT_VERSION = 1

export const SIGNATURE_ACKNOWLEDGEMENT_TEXT =
  'I confirm that I am the signed-in account holder and that I am signing this document myself. I am not a third party, and I am not signing on someone else’s behalf. Third-party signatures are not allowed.'

export const SIGNATURE_METADATA_NOTICE =
  'For security and authentication, LTS keeps metadata with each signature, including your account, the time you confirmed your identity, and device information.'

export type SignatureAuth = {
  acknowledged: boolean
  acknowledgementVersion: number
  confirmedAt: string
  userId: string
  username?: string
  employeeId?: string
  token: string
  userAgent?: string
}

export function hasSignatureIdentity(value: unknown): boolean {
  if (!value || typeof value !== 'object') return false
  const auth = (value as { auth?: SignatureAuth }).auth
  return !!(auth?.acknowledged && auth?.token)
}

export function isCompleteSignatureValue(value: unknown): boolean {
  if (!value || typeof value !== 'object') return false
  const dataUrl = (value as { dataUrl?: unknown }).dataUrl
  return !!dataUrl && hasSignatureIdentity(value)
}
